import axios from 'axios';
import _orderBy from 'lodash.orderby';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import Errors from '../classes/errors';
import {
    checkCCM19Consent,
    checkOneTrustConsent,
    handleCloseDropdownOnBlur,
    handleCloseInputDropdownOnBlur,
    handleFusedeckSubmitDatalayer,
    handleLoadSharpsringScriptUrl,
    handleSetSharpspringScript,
    handleSharpspringSubmit,
    normalizeModelName,
    setCaptchaEuScript,
} from '../utils';

Vue.component('request-testdrive-component', {
    props: {
        stores: {
            value: Array,
        },
        distributors: {
            value: Array,
        },
        siteHandle: {
            value: String,
        },
        testdriveModels: {
            value: Array,
        },
        defaultModel: {
            value: String,
        },
        resetCountries: {
            value: Boolean,
        },
        brandstoreResultAmount: {
            value: Number,
        },
        sharpspringBaseUrl: {
            value: String,
        },
        sharpspringEndpointId: {
            value: String,
        },
        sharpspringScriptUrl: {
            value: String,
        },
        captchaEuPublicKey: {
            value: String,
        },
        isExternalTestDriveForm: {
            value: Boolean,
        },
        isCaptchaEuEnabled: {
            value: Boolean,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            successMessage: '',
            formCompleted: false,
            submitting: false,
            selectedBrandStore: null,
            requestType: 'private',
            requestIndex: 0,
            countryHandle: '',
            color: 'white',
            heardFrom: null,

            model: '',
            modelName: 'MG ZS EV',

            dropdownCountry: null,
            dropdownHeardFrom: null,

            internalCountryHandle: '',
            frBrandStoreHandle: '',
            dropdownFrStore: '',
            dropdownFrStoreValue: '',
            frBrandStores: {
                martinique: 'MG Martinique (97232 Le Lamentin)',
                guadeloupe: 'MG Guadeloupe (97122 Baie-Mahault)',
                guyane: 'MG Guyane (97324 Cayenne Cedex)',
                mayotte: 'MG Mayotte (97 600 Mamoudzou)',
            },

            guyane: 'GF',
            martinique: 'GF',
            mayotte: 'YT',
            reunion: 'RE',
            guadeloupe: 'GP',

            isNumberValid: true,

            newsletterSignUp: false,
        };
    },

    computed: {
        orderedStores: function () {
            return _orderBy(this.stores, 'title');
        },

        isCompanyInputVisible: function () {
            return (
                this.requestType === 'business' || this.siteHandle === 'default'
            );
        },

        isPostalCodeInputVisible: function () {
            const countryList = [
                'mgMotorsNetherlands',
                'mgMotorsIceland',
                'mgMotorsNorway',
                'mgMotorsSpain',
                'mgMotorsItaly',
                'mgMotorsPortugal',
                'mgMotorsSweden',
                'mgMotorsHungary',
            ];

            return !countryList.includes(this.siteHandle);
        },

        isCityInputVisible: function () {
            const countries = ['default', 'mgMotorsFrance'];
            return countries.includes(this.siteHandle);
        },

        isCountryEurope: function () {
            return this.siteHandle === 'default';
        },

        isStreetNameInputVisible: function () {
            const countries = ['default'];
            return countries.includes(this.siteHandle);
        },

        isSubmitLoading: function () {
            return this.submitting ? 'button--loading' : '';
        },

        isSwitchButtonVisible: function () {
            const notAvailableCountries = [
                // 'mgMotorsGermany',
                'mgMotorsAustria',
            ];
            return !notAvailableCountries.includes(this.countryHandle);
        },
    },

    watch: {
        carId() {
            if (this.carId) {
                this.fetchAvailableDates();
            }
        },

        selectedDate() {
            if (this.selectedDate) {
                this.selectDate();
            }
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.model = this.defaultModel;
        if (this.siteHandle !== 'default') {
            this.countryHandle = this.siteHandle;
        }

        setCaptchaEuScript();

        handleCloseDropdownOnBlur('.new-input__dropdown-container--model');
        handleCloseDropdownOnBlur('#heard-from-dropdown');
        handleCloseDropdownOnBlur('#country-dropdown');
        handleCloseDropdownOnBlur('#brandstore-dropdown');
        handleCloseInputDropdownOnBlur(
            '#store-dropdown-container',
            '#searchBrandstore',
        );

        EventBus.$on('brandstore-selected', (brandstoreValue) => {
            this.selectedBrandStore = brandstoreValue;
        });

        if (this.isExternalTestDriveForm) {
            const html = document.getElementsByTagName('html')[0];
            html.style.background = 'white';
            html.style.minHeight = 'fit-content';
        }
    },

    created() {
        handleSetSharpspringScript(
            this.siteHandle,
            this.sharpspringBaseUrl,
            this.sharpspringEndpointId,
            'testDrive',
        );
        handleLoadSharpsringScriptUrl(
            this.siteHandle,
            this.sharpspringScriptUrl,
        );
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        handleToggleButtonActiveClass(index) {
            return this.requestIndex === index ? 'checked' : '';
        },

        handleMarketingConsentChange(e) {
            e.preventDefault();
            const isConsentChecked = e.target.checked;
            this.newsletterSignUp = isConsentChecked;
            const hiddenMarketingInput = document.querySelector('#marketing');
            if (!hiddenMarketingInput) return;
            hiddenMarketingInput.setAttribute(
                'value',
                isConsentChecked ? '1' : '0',
            );
        },

        scrollToFirstError() {
            Vue.nextTick(() => {
                let firstError = document.querySelector(
                    '.new-input__container--error',
                );
            });
        },

        scrollToTop() {
            Vue.nextTick(() => {
                zenscroll.toY(0);
            });
        },

        async onSubmit(event) {
            event.preventDefault();
            this.successMessage = '';
            const form = event.currentTarget;
            let formData = new FormData(form);
            const data = {};

            for (let [key, val] of formData.entries()) {
                Object.assign(data, { [key]: val });
            }

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            const isCompany =
                data.hasOwnProperty('company') && Boolean(data.company.length);

            const dataLayerData = {
                event: 'lead',
                lead_type: 'Test Drive',
                client_type: isCompany ? 'B2B' : 'B2C',
                brandstore: this.selectedBrandStore
                    ? this.selectedBrandStore.title
                    : '',
                payment_type: '',
                car: {
                    name: normalizeModelName(this.model),
                    ids: [],
                    edition: '',
                    color: '',
                },
                user_data: {
                    email_address: data.emailAddress,
                    phone_number: data.phone,
                    address: {
                        first_name: data.firstName,
                        last_name: data.lastName,
                    },
                },
            };

            if (!this.isNumberValid) {
                this.submitting = false;
                return;
            }

            try {
                if (!this.isCaptchaEuEnabled) {
                    await this.handleDataSubmit(form, dataLayerData);
                    return;
                }

                const captchaSolution = await KROT.getSolution(
                    this.captchaEuPublicKey,
                );

                await this.handleDataSubmit(
                    form,
                    dataLayerData,
                    captchaSolution,
                );
            } catch (e) {
                throw new Error(e);
            } finally {
                this.submitting = false;
            }
        },

        async handleDataSubmit(form, dataLayerData, captchaSolution) {
            try {
                const formData = new FormData(form);
                if (captchaSolution) {
                    formData.append(
                        'captchaSolution',
                        JSON.stringify(captchaSolution),
                    );
                }
                const response = await axios.post('/', formData);

                const result = response.data;

                if (result.data?.errors) {
                    this.errors.clear();
                    this.errors.record(result.data.errors);

                    this.scrollToFirstError();
                    this.submitting = false;
                    return;
                }

                // Success
                this.formCompleted = true;
                this.errors.clear();
                this.isNumberValid = true;

                this.sendGTMData(dataLayerData);
                handleSharpspringSubmit(
                    this.siteHandle,
                    this.sharpspringEndpointId,
                );

                const switzerlandCountries = [
                    'mgMotorsSwitzerlandIt',
                    'mgMotorsSwitzerlandDe',
                    'mgMotorsSwitzerlandFr',
                ];

                if (switzerlandCountries.includes(this.siteHandle)) {
                    await handleFusedeckSubmitDatalayer();
                }

                if (this.isExternalTestDriveForm) {
                    this.successMessage = result.data['form-general-success'];
                    return;
                }

                setTimeout(() => {
                    window.location = result.data.redirectUrl;
                }, 1000);
            } catch (e) {
                throw new Error(e);
            }
        },

        sendGTMData(extraDataToPush) {
            const country =
                this.siteHandle == 'default'
                    ? 'mgMotorsEurope'
                    : this.siteHandle;

            if (checkCCM19Consent() || checkOneTrustConsent()) {
                // check if you are on production-enviroment
                if (!window.dataLayer) {
                    window.dataLayer = window.dataLayer || [];
                }

                if (extraDataToPush) {
                    window.dataLayer.push(extraDataToPush);
                }

                window.dataLayer.push({
                    event: 'request test drive',
                    model: normalizeModelName(this.model),
                    edition: ' ',
                    page_path: window.location.href,
                    country: `${country} - ${this.$root.languageCode}`,
                });
            }
        },

        toggleDropdown(event) {
            event.preventDefault();
            let element = event.currentTarget;

            while ((element = element.parentElement)) {
                if (element.classList.contains('dropdown')) {
                    element.classList.toggle('dropdown--active');
                }
            }
        },

        setDropdownCountry(event) {
            event.preventDefault();
            this.toggleDropdown(event);

            this.dropdownCountry = event.currentTarget.dataset.text;
            this.countryHandle = event.currentTarget.dataset.value;
            this.internalCountryHandle = event.currentTarget.dataset.dorm;

            const territory = event.currentTarget.dataset.dorm;
            if (
                ['guyane', 'guadeloupe', 'martinique', 'mayotte'].includes(
                    territory,
                )
            ) {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = territory;
                this.dropdownFrStore = this.frBrandStores[territory];

                this.dropdownFrStoreValue = this.frBrandStores[territory];

                return;
            }

            if (territory === 'reunion') {
                this.internalCountryHandle = territory;
                this.frBrandStoreHandle = 'MG Saint-Pierre (97 410)';
                this.dropdownFrStore = 'MG Saint-Pierre (97 410)';
                this.dropdownFrStoreValue = 'MG Saint-Pierre (97 410)';
            }
        },

        setDropdownFrBrandStore(event) {
            event.preventDefault();
            const text = event.currentTarget.dataset.text;
            this.dropdownFrStore = text;
            this.dropdownFrStoreValue = text;

            this.frBrandStoreHandle = event.currentTarget.dataset.value;

            this.toggleDropdown(event);
        },

        resetCountryDropdown() {
            if (!this.resetCountries) {
                return;
            }

            this.dropdownCountry = null;
            this.countryHandle = '';
        },

        setDropdownHeardFrom(event) {
            event.preventDefault();
            this.dropdownHeardFrom = event.currentTarget.dataset.text;
            this.toggleDropdown(event);

            const value = event.currentTarget.dataset.value;
            this.heardFrom = value;
        },
    },
});
